import React from 'react'
import { IconButton } from 'shared/ui'

const MergeButton = React.memo(
  ({ mergeOpen, onMergeIconClick, MergeDropdown }) => {
    return (
      <div className="merge">
        {!mergeOpen && (
          <IconButton
            name="codeBranch"
            size="medium"
            className="menu-button"
            onClick={onMergeIconClick}
            tooltip="Merge [m]"
            svg
            data-test-id="MoreMenuMergeTicketOption"
          />
        )}
        {mergeOpen && (
          <MergeDropdown
            open
            trigger={
              <IconButton
                name="codeBranch"
                size="medium"
                className="menu-button"
                svg
              />
            }
          />
        )}
      </div>
    )
  }
)

export default MergeButton
